import { createContext } from 'react';

const AppDataContext = createContext(null);

export default AppDataContext;
